import { render } from "./TimeAndCostForm.vue?vue&type=template&id=56a6f4a4&scoped=true"
import script from "./TimeAndCostForm.vue?vue&type=script&lang=js"
export * from "./TimeAndCostForm.vue?vue&type=script&lang=js"

import "./TimeAndCostForm.vue?vue&type=style&index=0&id=56a6f4a4&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a6f4a4"]])

export default __exports__